import React from "react";

const ApplicationsBrokerFormPage = () => <pre>Broker form for an Application!</pre>

export default ApplicationsBrokerFormPage;